import { render } from "./OrderDetails.vue?vue&type=template&id=01ac4364&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=01ac4364&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ac4364"]])

export default __exports__